export default __webpack_public_path__ + "static/15-9c06719a5caf399c97e1e864540b3b4d.jpg";